/*
src/App.js
wgbh-skydiagram-testing
astro.unl.edu
2019-07-15
*/


import React from 'react';
import './App.css';

import 'normalize.css/normalize.css';
import '@blueprintjs/icons/lib/css/blueprint-icons.css';
import '@blueprintjs/core/lib/css/blueprint.css';


import {Workspace} from './data/Workspace.js';
import {LocalComms} from './local/LocalComms.js';

import {LayoutPanel} from './ui-panels/LayoutPanel.js';
import {TrackPanel} from './ui-panels/TrackPanel.js';
import {SunPanel} from './ui-panels/SunPanel.js';
import {MoonPanel} from './ui-panels/MoonPanel.js';
import {SkyPanel} from './ui-panels/SkyPanel.js';
import {GroundPanel} from './ui-panels/GroundPanel.js';
import {ForegroundImagesPanel} from './ui-panels/ForegroundImagesPanel.js';
import {ForegroundObjectsPanel} from './ui-panels/ForegroundObjectsPanel.js';

import {Button} from '@blueprintjs/core';
import {FocusStyleManager} from '@blueprintjs/core';
import {Tab, Tabs, Callout, H4} from '@blueprintjs/core';


const BASE_PATH = '/WGBH/sky-diagram-testing';//'; // '/


export default class App extends React.Component {


	constructor(props) {
		super(props);

		FocusStyleManager.onlyShowFocusOnTabs();

		this.needsRender = this.needsRender.bind(this);
		this.onTabChange = this.onTabChange.bind(this);
		this.onLaunchPreview = this.onLaunchPreview.bind(this);
		this.handleCopySettings = this.handleCopySettings.bind(this);
		
		this._workspace = new Workspace(BASE_PATH);
		if (!this._workspace.getIsReady()) {
			this._workspace.registerCallback('ready', this.needsRender);
		}

		this._localComms = new LocalComms(this._workspace);
		this._localComms.registerCallback('change', this.needsRender);

		this.state = {
			selectedTabId: 'layout-tab',
			dirtyCount: 1,
		};
	}


	needsRender() {
		this.setState(state => ({dirtyCount: state.dirtyCount+1}));
	}

	onLaunchPreview() {
		this._localComms.launchPreview();
	}

	onTabChange(newTabId, prevTabId, e) {
		this.setState(state => ({
			selectedTabId: newTabId
		}));
	}

	handleCopySettings(e) {
		let settings = JSON.stringify(this._workspace.getParamsManager().getParams(), null, 1);
		console.group('Will copy settings...');
		console.log(settings);
		console.groupEnd();
		let field = document.getElementById("hidden-copy-field");
		if (field !== null) {
			field.textContent = settings;
			field.select();
			document.execCommand("copy");	
			e.preventDefault();
		}
	}


	render() {

		if (!this._workspace.getIsReady()) {
			return (<div>loading</div>);
		}

	  return (
			<div>
	    	<div style={{maxWidth: "1000px", margin: "50px auto", padding: "20px 40px", backgroundColor: "white"}}>

					<Callout intent="warning">
						<H4>Warning</H4>
						Do not open this app in more than one window at a time.
					</Callout>
				
					<Callout intent="primary">
						The preview window will need to be re-opened every time this page is loaded.
					</Callout>

					<Button onClick={this.onLaunchPreview} disabled={!this._localComms.getIsLaunchAllowed()} icon="share" style={{margin: "30px 0 40px 0"}}>
						Open Preview Window
					</Button>

					<Button icon="clipboard" onClick={this.handleCopySettings} style={{margin: "30px 0 40px 0", float: "right"}}>
						Copy Settings To Clipboard
					</Button>

					<Tabs onChange={this.onTabChange} selectedTabId={this.state.selectedTabId}>
						<Tab id="layout-tab" title="Layout" panel={<LayoutPanel workspace={this._workspace} />} />
						<Tab id="track-tab" title="Sun-Moon Track" panel={<TrackPanel workspace={this._workspace} />} />
						<Tab id="sun-tab" title="Sun" panel={<SunPanel workspace={this._workspace} />} />
						<Tab id="moon-tab" title="Moon" panel={<MoonPanel workspace={this._workspace} />} />
						<Tab id="sky-tab" title="Sky" panel={<SkyPanel workspace={this._workspace} />} />
						<Tab id="ground-tab" title="Ground" panel={<GroundPanel workspace={this._workspace} />} />
						<Tab id="foreground-images-tab" title="Foreground Images" panel={<ForegroundImagesPanel workspace={this._workspace} />} />
						<Tab id="foreground-objects-tab" title="Foreground Objects" panel={<ForegroundObjectsPanel workspace={this._workspace} />} />
					</Tabs>

	    	</div>
			</div>
	  );
	}
}

